import { playgroundApi } from '../../common/api-client';
import {
  BaseMonthlyPolicyRow, BasePolicyRow, Coverages, PremiumBreakdown, SimulationWarning,
  buildRatePayload,
} from '../_shared';
import { APVSelectOneFormValues } from './schema';

export const PRODUCT = 'APV_SELECT_ONE';

export interface APVSelectOnePolicyRow extends BasePolicyRow {
  fiscal_contributions?: number;
}

export interface APVSelectOneMonthlyRow extends BaseMonthlyPolicyRow {
  fiscal_contributions?: number;
}

export interface APVSelectOneResponse {
  coverages: Coverages;
  currency: string;
  uf_value: number;
  premium: PremiumBreakdown;
  monthly_pension_with_afp: number;
  monthly_pension_afp_with_apv_transfer: number;
  monthly_pension_afp_apv_transfer_and_bice: number;
  total_monthly_projected_pension: number;
  total_afp_savings: number;
  total_apv_savings: number;
  total_savings: number;
  projection_by_year: APVSelectOnePolicyRow[];
  projection_by_month?: APVSelectOneMonthlyRow[];
  warnings?: SimulationWarning[];
}

export interface SimulateParams {
  values: APVSelectOneFormValues;
}

export function buildAPVSelectOnePayload(values: APVSelectOneFormValues) {
  const {
    rate_mode: _rateMode,
    projection_rate: _projectionRate,
    projection_rate_schedule: _projectionRateSchedule,
    direct_contribution_amount,
    direct_contribution_month,
    ...rest
  } = values;
  const direct_contribution = direct_contribution_amount > 0
    ? { amount: direct_contribution_amount, kind: 'UNIQUE', month: direct_contribution_month }
    : undefined;
  return {
    ...rest,
    ...buildRatePayload(values),
    ...(direct_contribution ? { direct_contribution } : {}),
  };
}

export async function simulateAPVSelectOne({
  values,
}: SimulateParams): Promise<APVSelectOneResponse> {
  const payload = {
    product: PRODUCT, ...buildAPVSelectOnePayload(values), origin_process_id: 1, debug: true,
  };
  const { data } = await playgroundApi.post<APVSelectOneResponse>(
    'projection/',
    payload,
  );
  return data;
}
